module.exports = __webpack_public_path__ + "img/icon-ketang-logo.9149b636.png";